import { useContext, useEffect, useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminQueryCenter, AdminQueryDivision, AdminQueryPublicHoliday, AdminQueryUsage } from "../../backend/src/api/dto"
import { IconName } from '@fortawesome/free-solid-svg-icons';
import ModalConfirmation from "./Modal/Confirmation"
import DisplayUsage from "./components/DisplayUsage"
import { months } from "./global"
import AdminAddPublicHoliday from "./Modal/AdminAddPublicHoliday"
import { AdminAddPublicHolidayFunction, AdminEditPublicHolidayFunction } from "./interfaces"


function SettingHolidays() {

    const [data, setData] = useState<AdminQueryPublicHoliday[]>([])
    const [showModal, closeModal] = useContext(ModalContext);


    useEffect(() => {
        reloadData();
    }, [])


    const reloadData = () => {
        return API.getPublicHolidays().then(res => {
            setData(res)
        })
    }

    const deletePublicHoliday = (id: number) => {
        return API.deletePublicHoliday(id).then(res => {
            setData(data.filter(d => d.publicHolidayId !== id))
            closeModal(null);
        })
    }

    const addPublicHoliday: AdminAddPublicHolidayFunction = (name, day, month, func, fromYear, toYear) => {
        return API.addPublicHoliday(name, day, month, func, fromYear, toYear).then(holiday => {
            closeModal(null);
            return reloadData()
        })
    }

    const setPublicHoliday: AdminEditPublicHolidayFunction = (publicHolidayId, name, day, month, func, fromYear, toYear) => {
        return API.setPublicHoliday(publicHolidayId, name, day, month, func, fromYear, toYear).then(holiday => {
            closeModal(null);
            return reloadData()
        })
    }

    return (
        <div className="p-3">
            <button className="btn btn-success ms-3" style={{position: "absolute", right: "16px", top: "8px"}} onClick={() => showModal(
                <AdminAddPublicHoliday
                    item={null}
                    addFunction={addPublicHoliday}
                    setFunction={setPublicHoliday}
                    reload={reloadData}
                />
            )}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať sviatok</button>

            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Meno sviatku</th>
                        <th>Deň</th>
                        <th>Mesiac</th>
                        <th>Od roku</th>
                        <th>Do roku</th>
                        <th>Funkcia</th>

                        <th className="text-center" style={{ width: '280px' }}>Akcia</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map(day => {
                            return (
                                <tr>
                                    <td>{day.name}</td>
                                    <td>{day.day ?? 'Variabilný'}</td>
                                    <td>{day.month ? <>{months[day.month - 1]}  <small>({day.month})</small></> : 'Variabilný'}</td>
                                    <td>{day.fromYear}</td>
                                    <td>{day.toYear}</td>
                                    <td>{day.function}</td>
                                    <td className="text-center">
                                        <button className="btn btn-danger ms-3" onClick={() => showModal(
                                            <ModalConfirmation
                                                confirm={() => deletePublicHoliday(day.publicHolidayId!)}
                                                title={"Naozaj zmazať sviatok ?"}
                                            >
                                                <p className="alert alert-danger">Táto akcia je nevratná.</p>
                                                <p>Meno: {day.name}<br />Deň: {day.day}<br />Mesiac: {day.month}<br />Od roku: {day.fromYear}<br />Do roku: {day.toYear}</p>
                                            </ModalConfirmation>
                                        )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Zmazať</button>


                                        <button className="btn btn-primary ms-3" onClick={() => showModal(
                                            <AdminAddPublicHoliday
                                                item={day}
                                                setFunction={setPublicHoliday}
                                                addFunction={addPublicHoliday}
                                                reload={reloadData}
                                            />
                                        )}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}


export default SettingHolidays